import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Story.css";
import TextStoryComponent from "./TextStoryComponent";
import ComicsStoryComponent from "./Comics/ComicsStoryComponent";
import TutorialComponent from "../../tutorial/TutorialComponent";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { MusicService } from "../../../services/MusicService";
import { useActions } from "../../../hooks/useActions";

function StoryComponent() {
    const { cpuStory } = useTypedSelector((state) => state.auth);
    const { endGame } = useTypedSelector((state) => state.game);
    const { startGame, setRoute } = useActions();

    const [starting, setStarting] = useState(false);
    const startedRef = useRef(false);

    const StartGame = async () => {
        if (cpuStory.cpuId == null) return;
        setStarting(true);
        await startGame(cpuStory.cpuId);
        await new Promise((r) => setTimeout(r, 100));
        setRoute("game");
        MusicService.stopTutorial();
        MusicService.stopMenu();
        MusicService.playBattleMusic();
    };

    // Safely derive storyType & comicsSetting from state
    const { storyType, comicsSetting, shouldAutoStart } = useMemo(() => {
        let type: string | null = null;
        let comics: any = null;

        if (cpuStory.cpuNumber != null) {
            if (cpuStory.action === "before") {
                // read type
                type = cpuStory.story[cpuStory.cpuNumber]?.before?.type ?? null;
                if (type === "comics") {
                    comics = cpuStory.story[cpuStory.cpuNumber]?.before?.comicsSetting ?? null;
                }
            } else if (cpuStory.action && endGame.winner) {
                type =
                    cpuStory.story[cpuStory.cpuNumber]?.[cpuStory.action]?.[endGame.winner]
                        ?.type ?? null;
                if (type === "comics") {
                    comics =
                        cpuStory.story[cpuStory.cpuNumber]?.[cpuStory.action]?.[endGame.winner]
                            ?.comicsSetting ?? null;
                }
            }
        }

        const auto = cpuStory.action === "before" && type === "skip";
        return { storyType: type, comicsSetting: comics, shouldAutoStart: auto };
    }, [cpuStory, endGame.winner]);

    // Fire StartGame once when auto-start is requested
    useEffect(() => {
        if (shouldAutoStart && !startedRef.current) {
            startedRef.current = true;
            StartGame();
        }
    }, [shouldAutoStart]); // StartGame uses stable closures from hooks/refs

    // While starting (or auto-start triggered), render nothing or a loader
    if (starting || shouldAutoStart) {
        return null; // or return <div className="loader">Starting…</div>
    }

    return (
        <div className="map-main-story-layer">
            {storyType === "text" ? (
                <TextStoryComponent cpuStory={cpuStory} endGame={endGame} />
            ) : (
                <ComicsStoryComponent
                    comicsSetting={comicsSetting}
                    cpuStory={cpuStory}
                    closeComics={null}
                />
            )}
            <TutorialComponent />
        </div>
    );
}

export default StoryComponent;